module.exports = __webpack_public_path__ + "img/10.fddc9db4.jpg";